import { Col } from 'react-bootstrap';
import styled from 'styled-components';

export const WhyCol = styled(Col)`
      @media screen and (max-width: 600px) {
            order: ${(props) => props.order};
      }
`;
